import './services/authFetch';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import theme from './theme';
import ErrorBoundary from './components/common/ErrorBoundary';
import './assets/styles/main.css';
import './assets/styles/saffron-mock.css';
import { initConfig } from './services/configService';

// Initialize the configuration
console.log('Initializing application configuration...');
initConfig()
  .then(config => {
    console.log('Configuration initialized successfully:', config);
    
    // Create a root element for React to render into
    const root = ReactDOM.createRoot(document.getElementById('root'));

    // Render the App component with ThemeProvider and ErrorBoundary
    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </ErrorBoundary>
      </React.StrictMode>
    );
  })
  .catch(error => {
    console.error('Failed to initialize configuration:', error);
    
    // Create a root element for React to render into
    const root = ReactDOM.createRoot(document.getElementById('root'));

    // Render the App component with ThemeProvider even if configuration fails
    // The app will use default configuration values
    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </ErrorBoundary>
      </React.StrictMode>
    );
  });
